import React, { useEffect, useState } from 'react';
import { AppBar, Dialog, DialogActions, DialogContent, Tab, Tabs, Button } from '@material-ui/core';
import './UserProfile.css';
import LoadingPanel from '@/component/common/LoadingPanel';
import PersonalSettingTab from './PersonalSettingTab';
import UserProfileTab from './UserProfileTab';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { I18n } from 'aws-amplify';
import { closeTabId } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import Constant from '@/common/constant/Constant';

export default function UserProfile(props) {
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const [isLoading, setIsLoading] = useState(false);
    const [tabSelected, setTabSelected] = useState('userProfile');
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [submitChangeUserProfileStatus, setSubmitChangeUserProfileStatus] = useState(0);
    const [isProfileHasChange, setIsProfileHasChange] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(
        closeTabId
    );
    const [isClickCloseTab,setClickCloseTab] = useState(false)

    useEffect(() => {
        if (closeTabIdState === 'system_user_profile') {
            setClickCloseTab(true)
            if (isProfileHasChange) {
                setIsOpenDialog(true);
            } else {
                closePanelTab({
                    event: null,
                    panelType: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
                    panelId: props.panelId,
                    tabId: 'system_user_profile'
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const onChangeTab = (event, newValue) => {
        if (
            tabSelected === 'userProfile' &&
            newValue === 'persionalSetting' &&
            isProfileHasChange === true
        ) {
            setIsOpenDialog(true);
        } else {
            setTabSelected(newValue);
        }
    };

    const onClickBtnCloseDialog = (event, closePopup) => {
        setIsOpenDialog(false);
        if (isClickCloseTab) {
            closePanelTab({
                event: null,
                panelType: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
                panelId: props.panelId,
                tabId: 'system_user_profile'
            });
        } else {
            if (closePopup !== true) {
                setTabSelected('persionalSetting');
                setIsProfileHasChange(false)
            }
        }
    };
    const confirmSubmitChangeUserProfile = status => {
        setSubmitChangeUserProfileStatus(status);
        setIsOpenDialog(false);
    };
    const renderContenTab = tabSelect => {
        switch (tabSelect) {
            case 'userProfile': {
                return (
                    <UserProfileTab
                        setIsLoading={setIsLoading}
                        api={props?.API}
                        submitChangeUserProfileStatus={submitChangeUserProfileStatus}
                        setSubmitChangeUserProfileStatus={setSubmitChangeUserProfileStatus}
                        setIsProfileHasChange={setIsProfileHasChange}
                        setTabSelected={setTabSelected}
                        {...props}
                    />
                );
            }
            case 'persionalSetting': {
                return <PersonalSettingTab userDetail={userDetail} API={props?.API} />;
            }
            default: {
                return <div>Nothing to show</div>;
            }
        }
    };

    return (
        <div className="userProfile">
            <LoadingPanel isLoading={isLoading} />
            {/* user detail */}
            <div className="tabList">
                <div className="navTabs">
                    <AppBar className="navTabs-box" position="static">
                        <Tabs
                            className="navTabs-rot"
                            value={tabSelected}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            onChange={onChangeTab}
                        >
                            <Tab
                                className="navTabs--item custom-tab"
                                label="ユーザープロフィール"
                                value="userProfile"
                            />
                            <Tab
                                className="navTabs--item custom-tab"
                                label="通知設定"
                                value="persionalSetting"
                            />
                        </Tabs>
                    </AppBar>
                </div>
                <Dialog
                open={isOpenDialog}
                onClose={(event, reason) => onClickBtnCloseDialog(event, true)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
                // disableBackdropClick="true"
            >
                {/* <DialogTitle className="titleHeader">
                        <h2 className="title">{I18n.get('COMLB001')}</h2>
                    </DialogTitle> */}
                <DialogContent>
                    <div className="confirm-dialog-content">{I18n.get('COMMSG004')}</div>
                </DialogContent>
                <DialogActions className="confirm-dialog-action">
                    {/* btn confirm */}
                    {isClickCloseTab ? <Button
                        className="btn-hg32 btn-handle-delete-user-agree"
                        variant="contained"
                        onClick={e => confirmSubmitChangeUserProfile(2)}
                    >
                        {I18n.get('COMBTN002')}
                    </Button> :  <Button
                        className="btn-hg32 btn-handle-delete-user-agree"
                        variant="contained"
                        onClick={e => confirmSubmitChangeUserProfile(1)}
                    >
                        {I18n.get('COMBTN002')}
                    </Button>}
                    {/* btn cancel */}
                    <Button
                        className="btn-light btn-hg32"
                        variant="contained"
                        onClick={onClickBtnCloseDialog}
                    >
                        {I18n.get('COMBTN007')}
                    </Button>
                </DialogActions>
            </Dialog>
            </div>
            {renderContenTab(tabSelected)}
        </div>
    );
}
